import * as ambassadorWixEventsV3Event from './events-v3-event-wix-events-v-2.http.js';
import * as ambassadorWixEventsV3EventTypes from './events-v3-event-wix-events-v-2.types.js';
import * as ambassadorWixEventsV3EventUniversalTypes from './events-v3-event-wix-events-v-2.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createEvent(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV3EventUniversalTypes.CreateEventRequest,
  ambassadorWixEventsV3EventTypes.CreateEventRequest,
  ambassadorWixEventsV3EventUniversalTypes.CreateEventResponse,
  ambassadorWixEventsV3EventTypes.CreateEventResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEventsV3Event.createEvent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/events',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function cloneEvent(): __PublicMethodMetaInfo<
  'POST',
  { eventId: string },
  ambassadorWixEventsV3EventUniversalTypes.CloneEventRequest,
  ambassadorWixEventsV3EventTypes.CloneEventRequest,
  ambassadorWixEventsV3EventUniversalTypes.CloneEventResponse,
  ambassadorWixEventsV3EventTypes.CloneEventResponse
> {
  const payload = { eventId: ':eventId' } as any;

  const getRequestOptions = ambassadorWixEventsV3Event.cloneEvent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/events/{eventId}/clone',
    pathParams: { eventId: 'eventId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateEvent(): __PublicMethodMetaInfo<
  'PATCH',
  { eventId: string },
  ambassadorWixEventsV3EventUniversalTypes.UpdateEventRequest,
  ambassadorWixEventsV3EventTypes.UpdateEventRequest,
  ambassadorWixEventsV3EventUniversalTypes.UpdateEventResponse,
  ambassadorWixEventsV3EventTypes.UpdateEventResponse
> {
  const payload = { event: { id: ':eventId' } } as any;

  const getRequestOptions = ambassadorWixEventsV3Event.updateEvent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v3/events/{event.id}',
    pathParams: { eventId: 'eventId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function publishDraftEvent(): __PublicMethodMetaInfo<
  'POST',
  { eventId: string },
  ambassadorWixEventsV3EventUniversalTypes.PublishDraftEventRequest,
  ambassadorWixEventsV3EventTypes.PublishDraftEventRequest,
  ambassadorWixEventsV3EventUniversalTypes.PublishDraftEventResponse,
  ambassadorWixEventsV3EventTypes.PublishDraftEventResponse
> {
  const payload = { eventId: ':eventId' } as any;

  const getRequestOptions =
    ambassadorWixEventsV3Event.publishDraftEvent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/events/{eventId}/publish',
    pathParams: { eventId: 'eventId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function cancelEvent(): __PublicMethodMetaInfo<
  'POST',
  { eventId: string },
  ambassadorWixEventsV3EventUniversalTypes.CancelEventRequest,
  ambassadorWixEventsV3EventTypes.CancelEventRequest,
  ambassadorWixEventsV3EventUniversalTypes.CancelEventResponse,
  ambassadorWixEventsV3EventTypes.CancelEventResponse
> {
  const payload = { eventId: ':eventId' } as any;

  const getRequestOptions = ambassadorWixEventsV3Event.cancelEvent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/events/{eventId}/cancel',
    pathParams: { eventId: 'eventId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCancelEventsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV3EventUniversalTypes.BulkCancelEventsByFilterRequest,
  ambassadorWixEventsV3EventTypes.BulkCancelEventsByFilterRequest,
  ambassadorWixEventsV3EventUniversalTypes.BulkCancelEventsByFilterResponse,
  ambassadorWixEventsV3EventTypes.BulkCancelEventsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsV3Event.bulkCancelEventsByFilter(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/events/cancel-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteEvent(): __PublicMethodMetaInfo<
  'DELETE',
  { eventId: string },
  ambassadorWixEventsV3EventUniversalTypes.DeleteEventRequest,
  ambassadorWixEventsV3EventTypes.DeleteEventRequest,
  ambassadorWixEventsV3EventUniversalTypes.DeleteEventResponse,
  ambassadorWixEventsV3EventTypes.DeleteEventResponse
> {
  const payload = { eventId: ':eventId' } as any;

  const getRequestOptions = ambassadorWixEventsV3Event.deleteEvent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v3/events/{eventId}',
    pathParams: { eventId: 'eventId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteEventsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV3EventUniversalTypes.BulkDeleteEventsByFilterRequest,
  ambassadorWixEventsV3EventTypes.BulkDeleteEventsByFilterRequest,
  ambassadorWixEventsV3EventUniversalTypes.BulkDeleteEventsByFilterResponse,
  ambassadorWixEventsV3EventTypes.BulkDeleteEventsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsV3Event.bulkDeleteEventsByFilter(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/events/delete-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryEvents(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV3EventUniversalTypes.QueryEventsRequest,
  ambassadorWixEventsV3EventTypes.QueryEventsRequest,
  ambassadorWixEventsV3EventUniversalTypes.QueryEventsResponse,
  ambassadorWixEventsV3EventTypes.QueryEventsResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEventsV3Event.queryEvents(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/events/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function countEventsByStatus(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV3EventUniversalTypes.CountEventsByStatusRequest,
  ambassadorWixEventsV3EventTypes.CountEventsByStatusRequest,
  ambassadorWixEventsV3EventUniversalTypes.CountEventsByStatusResponse,
  ambassadorWixEventsV3EventTypes.CountEventsByStatusResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsV3Event.countEventsByStatus(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/events/count-by-status',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listEventsByCategory(): __PublicMethodMetaInfo<
  'GET',
  { categoryId: string },
  ambassadorWixEventsV3EventUniversalTypes.ListEventsByCategoryRequest,
  ambassadorWixEventsV3EventTypes.ListEventsByCategoryRequest,
  ambassadorWixEventsV3EventUniversalTypes.ListEventsByCategoryResponse,
  ambassadorWixEventsV3EventTypes.ListEventsByCategoryResponse
> {
  const payload = { categoryId: ':categoryId' } as any;

  const getRequestOptions =
    ambassadorWixEventsV3Event.listEventsByCategory(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/events/category/{categoryId}',
    pathParams: { categoryId: 'categoryId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getEvent(): __PublicMethodMetaInfo<
  'GET',
  { eventId: string },
  ambassadorWixEventsV3EventUniversalTypes.GetEventRequest,
  ambassadorWixEventsV3EventTypes.GetEventRequest,
  ambassadorWixEventsV3EventUniversalTypes.GetEventResponse,
  ambassadorWixEventsV3EventTypes.GetEventResponse
> {
  const payload = { eventId: ':eventId' } as any;

  const getRequestOptions = ambassadorWixEventsV3Event.getEvent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/events/{eventId}',
    pathParams: { eventId: 'eventId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getEventBySlug(): __PublicMethodMetaInfo<
  'GET',
  { slug: string },
  ambassadorWixEventsV3EventUniversalTypes.GetEventBySlugRequest,
  ambassadorWixEventsV3EventTypes.GetEventBySlugRequest,
  ambassadorWixEventsV3EventUniversalTypes.GetEventBySlugResponse,
  ambassadorWixEventsV3EventTypes.GetEventBySlugResponse
> {
  const payload = { slug: ':slug' } as any;

  const getRequestOptions = ambassadorWixEventsV3Event.getEventBySlug(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/events/slug/{slug}',
    pathParams: { slug: 'slug' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Event as EventOriginal,
  Location as LocationOriginal,
  LocationType as LocationTypeOriginal,
  LocationTypeWithLiterals as LocationTypeWithLiteralsOriginal,
  Address as AddressOriginal,
  AddressStreetOneOf as AddressStreetOneOfOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  Subdivision as SubdivisionOriginal,
  SubdivisionType as SubdivisionTypeOriginal,
  SubdivisionTypeWithLiterals as SubdivisionTypeWithLiteralsOriginal,
  DateAndTimeSettings as DateAndTimeSettingsOriginal,
  RecurrenceStatusStatus as RecurrenceStatusStatusOriginal,
  RecurrenceStatusStatusWithLiterals as RecurrenceStatusStatusWithLiteralsOriginal,
  Recurrences as RecurrencesOriginal,
  Occurrence as OccurrenceOriginal,
  Formatted as FormattedOriginal,
  TimeDuration as TimeDurationOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  PageUrl as PageUrlOriginal,
  Registration as RegistrationOriginal,
  RegistrationTypeType as RegistrationTypeTypeOriginal,
  RegistrationTypeTypeWithLiterals as RegistrationTypeTypeWithLiteralsOriginal,
  RegistrationStatusStatus as RegistrationStatusStatusOriginal,
  RegistrationStatusStatusWithLiterals as RegistrationStatusStatusWithLiteralsOriginal,
  RsvpRegistration as RsvpRegistrationOriginal,
  ResponseType as ResponseTypeOriginal,
  ResponseTypeWithLiterals as ResponseTypeWithLiteralsOriginal,
  RsvpConfirmationMessages as RsvpConfirmationMessagesOriginal,
  PositiveResponseConfirmation as PositiveResponseConfirmationOriginal,
  NegativeResponseConfirmation as NegativeResponseConfirmationOriginal,
  TicketsRegistration as TicketsRegistrationOriginal,
  Money as MoneyOriginal,
  TaxSettings as TaxSettingsOriginal,
  TaxType as TaxTypeOriginal,
  TaxTypeWithLiterals as TaxTypeWithLiteralsOriginal,
  TicketsConfirmationMessages as TicketsConfirmationMessagesOriginal,
  CheckoutType as CheckoutTypeOriginal,
  CheckoutTypeWithLiterals as CheckoutTypeWithLiteralsOriginal,
  ExternalRegistration as ExternalRegistrationOriginal,
  GuestTypeType as GuestTypeTypeOriginal,
  GuestTypeTypeWithLiterals as GuestTypeTypeWithLiteralsOriginal,
  InitialRegistrationTypeType as InitialRegistrationTypeTypeOriginal,
  InitialRegistrationTypeTypeWithLiterals as InitialRegistrationTypeTypeWithLiteralsOriginal,
  Image as ImageOriginal,
  CalendarUrls as CalendarUrlsOriginal,
  Form as FormOriginal,
  InputControl as InputControlOriginal,
  InputControlType as InputControlTypeOriginal,
  InputControlTypeWithLiterals as InputControlTypeWithLiteralsOriginal,
  Input as InputOriginal,
  ValueType as ValueTypeOriginal,
  ValueTypeWithLiterals as ValueTypeWithLiteralsOriginal,
  OptionSelection as OptionSelectionOriginal,
  OptionSelectionSelectedOptionOneOf as OptionSelectionSelectedOptionOneOfOriginal,
  Label as LabelOriginal,
  FormMessages as FormMessagesOriginal,
  RsvpFormMessages as RsvpFormMessagesOriginal,
  RsvpFormMessagesPositiveResponseConfirmation as RsvpFormMessagesPositiveResponseConfirmationOriginal,
  RsvpFormMessagesNegativeResponseConfirmation as RsvpFormMessagesNegativeResponseConfirmationOriginal,
  Positive as PositiveOriginal,
  Negative as NegativeOriginal,
  CheckoutFormMessages as CheckoutFormMessagesOriginal,
  ResponseConfirmation as ResponseConfirmationOriginal,
  RegistrationClosedMessages as RegistrationClosedMessagesOriginal,
  TicketsUnavailableMessages as TicketsUnavailableMessagesOriginal,
  Summaries as SummariesOriginal,
  EventsMoney as EventsMoneyOriginal,
  Rsvps as RsvpsOriginal,
  Tickets as TicketsOriginal,
  GuestListSettings as GuestListSettingsOriginal,
  Feed as FeedOriginal,
  OnlineConferencing as OnlineConferencingOriginal,
  ConferenceTypeType as ConferenceTypeTypeOriginal,
  ConferenceTypeTypeWithLiterals as ConferenceTypeTypeWithLiteralsOriginal,
  OnlineConferencingSession as OnlineConferencingSessionOriginal,
  SeoSettings as SeoSettingsOriginal,
  SeoSchema as SeoSchemaOriginal,
  Keyword as KeywordOriginal,
  Tag as TagOriginal,
  Settings as SettingsOriginal,
  AgendaSettings as AgendaSettingsOriginal,
  EventCategories as EventCategoriesOriginal,
  EventCategory as EventCategoryOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  EventDisplaySettings as EventDisplaySettingsOriginal,
  LabellingSettings as LabellingSettingsOriginal,
  RichContent as RichContentOriginal,
  Node as NodeOriginal,
  NodeDataOneOf as NodeDataOneOfOriginal,
  NodeType as NodeTypeOriginal,
  NodeTypeWithLiterals as NodeTypeWithLiteralsOriginal,
  NodeStyle as NodeStyleOriginal,
  ButtonData as ButtonDataOriginal,
  BackgroundType as BackgroundTypeOriginal,
  BackgroundTypeWithLiterals as BackgroundTypeWithLiteralsOriginal,
  Gradient as GradientOriginal,
  GradientType as GradientTypeOriginal,
  GradientTypeWithLiterals as GradientTypeWithLiteralsOriginal,
  Stop as StopOriginal,
  Border as BorderOriginal,
  Colors as ColorsOriginal,
  Background as BackgroundOriginal,
  PluginContainerData as PluginContainerDataOriginal,
  WidthType as WidthTypeOriginal,
  WidthTypeWithLiterals as WidthTypeWithLiteralsOriginal,
  PluginContainerDataWidth as PluginContainerDataWidthOriginal,
  PluginContainerDataWidthDataOneOf as PluginContainerDataWidthDataOneOfOriginal,
  PluginContainerDataAlignment as PluginContainerDataAlignmentOriginal,
  PluginContainerDataAlignmentWithLiterals as PluginContainerDataAlignmentWithLiteralsOriginal,
  Spoiler as SpoilerOriginal,
  Height as HeightOriginal,
  ButtonDataType as ButtonDataTypeOriginal,
  ButtonDataTypeWithLiterals as ButtonDataTypeWithLiteralsOriginal,
  Styles as StylesOriginal,
  Link as LinkOriginal,
  LinkDataOneOf as LinkDataOneOfOriginal,
  Target as TargetOriginal,
  TargetWithLiterals as TargetWithLiteralsOriginal,
  Rel as RelOriginal,
  CodeBlockData as CodeBlockDataOriginal,
  TextStyle as TextStyleOriginal,
  TextAlignment as TextAlignmentOriginal,
  TextAlignmentWithLiterals as TextAlignmentWithLiteralsOriginal,
  DividerData as DividerDataOriginal,
  LineStyle as LineStyleOriginal,
  LineStyleWithLiterals as LineStyleWithLiteralsOriginal,
  Width as WidthOriginal,
  WidthWithLiterals as WidthWithLiteralsOriginal,
  DividerDataAlignment as DividerDataAlignmentOriginal,
  DividerDataAlignmentWithLiterals as DividerDataAlignmentWithLiteralsOriginal,
  FileData as FileDataOriginal,
  ViewMode as ViewModeOriginal,
  ViewModeWithLiterals as ViewModeWithLiteralsOriginal,
  FileSource as FileSourceOriginal,
  FileSourceDataOneOf as FileSourceDataOneOfOriginal,
  PDFSettings as PDFSettingsOriginal,
  GalleryData as GalleryDataOriginal,
  Media as MediaOriginal,
  ItemImage as ItemImageOriginal,
  Video as VideoOriginal,
  Item as ItemOriginal,
  ItemDataOneOf as ItemDataOneOfOriginal,
  GalleryOptions as GalleryOptionsOriginal,
  LayoutType as LayoutTypeOriginal,
  LayoutTypeWithLiterals as LayoutTypeWithLiteralsOriginal,
  Orientation as OrientationOriginal,
  OrientationWithLiterals as OrientationWithLiteralsOriginal,
  Crop as CropOriginal,
  CropWithLiterals as CropWithLiteralsOriginal,
  ThumbnailsAlignment as ThumbnailsAlignmentOriginal,
  ThumbnailsAlignmentWithLiterals as ThumbnailsAlignmentWithLiteralsOriginal,
  GalleryOptionsLayout as GalleryOptionsLayoutOriginal,
  ItemStyle as ItemStyleOriginal,
  Thumbnails as ThumbnailsOriginal,
  GIFData as GIFDataOriginal,
  GIF as GIFOriginal,
  GIFType as GIFTypeOriginal,
  GIFTypeWithLiterals as GIFTypeWithLiteralsOriginal,
  HeadingData as HeadingDataOriginal,
  HTMLData as HTMLDataOriginal,
  HTMLDataDataOneOf as HTMLDataDataOneOfOriginal,
  Source as SourceOriginal,
  SourceWithLiterals as SourceWithLiteralsOriginal,
  ImageData as ImageDataOriginal,
  StylesBorder as StylesBorderOriginal,
  ImageDataStyles as ImageDataStylesOriginal,
  LinkPreviewData as LinkPreviewDataOriginal,
  StylesPosition as StylesPositionOriginal,
  StylesPositionWithLiterals as StylesPositionWithLiteralsOriginal,
  LinkPreviewDataStyles as LinkPreviewDataStylesOriginal,
  MapData as MapDataOriginal,
  MapSettings as MapSettingsOriginal,
  MapType as MapTypeOriginal,
  MapTypeWithLiterals as MapTypeWithLiteralsOriginal,
  ParagraphData as ParagraphDataOriginal,
  PollData as PollDataOriginal,
  ViewRole as ViewRoleOriginal,
  ViewRoleWithLiterals as ViewRoleWithLiteralsOriginal,
  VoteRole as VoteRoleOriginal,
  VoteRoleWithLiterals as VoteRoleWithLiteralsOriginal,
  Permissions as PermissionsOriginal,
  Option as OptionOriginal,
  PollSettings as PollSettingsOriginal,
  PollLayoutType as PollLayoutTypeOriginal,
  PollLayoutTypeWithLiterals as PollLayoutTypeWithLiteralsOriginal,
  PollLayoutDirection as PollLayoutDirectionOriginal,
  PollLayoutDirectionWithLiterals as PollLayoutDirectionWithLiteralsOriginal,
  PollLayout as PollLayoutOriginal,
  OptionLayout as OptionLayoutOriginal,
  PollDesignBackgroundType as PollDesignBackgroundTypeOriginal,
  PollDesignBackgroundTypeWithLiterals as PollDesignBackgroundTypeWithLiteralsOriginal,
  BackgroundGradient as BackgroundGradientOriginal,
  PollDesignBackground as PollDesignBackgroundOriginal,
  PollDesignBackgroundBackgroundOneOf as PollDesignBackgroundBackgroundOneOfOriginal,
  PollDesign as PollDesignOriginal,
  OptionDesign as OptionDesignOriginal,
  Poll as PollOriginal,
  PollDataLayout as PollDataLayoutOriginal,
  Design as DesignOriginal,
  TextData as TextDataOriginal,
  Decoration as DecorationOriginal,
  DecorationDataOneOf as DecorationDataOneOfOriginal,
  DecorationType as DecorationTypeOriginal,
  DecorationTypeWithLiterals as DecorationTypeWithLiteralsOriginal,
  AnchorData as AnchorDataOriginal,
  ColorData as ColorDataOriginal,
  LinkData as LinkDataOriginal,
  MentionData as MentionDataOriginal,
  FontSizeData as FontSizeDataOriginal,
  FontType as FontTypeOriginal,
  FontTypeWithLiterals as FontTypeWithLiteralsOriginal,
  SpoilerData as SpoilerDataOriginal,
  FontFamilyData as FontFamilyDataOriginal,
  AppEmbedData as AppEmbedDataOriginal,
  AppEmbedDataAppDataOneOf as AppEmbedDataAppDataOneOfOriginal,
  Position as PositionOriginal,
  PositionWithLiterals as PositionWithLiteralsOriginal,
  AspectRatio as AspectRatioOriginal,
  AspectRatioWithLiterals as AspectRatioWithLiteralsOriginal,
  Resizing as ResizingOriginal,
  ResizingWithLiterals as ResizingWithLiteralsOriginal,
  Placement as PlacementOriginal,
  PlacementWithLiterals as PlacementWithLiteralsOriginal,
  CardStylesType as CardStylesTypeOriginal,
  CardStylesTypeWithLiterals as CardStylesTypeWithLiteralsOriginal,
  Alignment as AlignmentOriginal,
  AlignmentWithLiterals as AlignmentWithLiteralsOriginal,
  Layout as LayoutOriginal,
  LayoutWithLiterals as LayoutWithLiteralsOriginal,
  AppType as AppTypeOriginal,
  AppTypeWithLiterals as AppTypeWithLiteralsOriginal,
  BookingData as BookingDataOriginal,
  EventData as EventDataOriginal,
  ButtonStyles as ButtonStylesOriginal,
  ImageStyles as ImageStylesOriginal,
  RibbonStyles as RibbonStylesOriginal,
  CardStyles as CardStylesOriginal,
  PricingData as PricingDataOriginal,
  VideoData as VideoDataOriginal,
  PlaybackOptions as PlaybackOptionsOriginal,
  EmbedData as EmbedDataOriginal,
  Oembed as OembedOriginal,
  CollapsibleListData as CollapsibleListDataOriginal,
  InitialExpandedItems as InitialExpandedItemsOriginal,
  InitialExpandedItemsWithLiterals as InitialExpandedItemsWithLiteralsOriginal,
  Direction as DirectionOriginal,
  DirectionWithLiterals as DirectionWithLiteralsOriginal,
  TableData as TableDataOriginal,
  Dimensions as DimensionsOriginal,
  TableCellData as TableCellDataOriginal,
  VerticalAlignment as VerticalAlignmentOriginal,
  VerticalAlignmentWithLiterals as VerticalAlignmentWithLiteralsOriginal,
  CellStyle as CellStyleOriginal,
  BorderColors as BorderColorsOriginal,
  BorderWidths as BorderWidthsOriginal,
  NullValue as NullValueOriginal,
  NullValueWithLiterals as NullValueWithLiteralsOriginal,
  ListValue as ListValueOriginal,
  AudioData as AudioDataOriginal,
  OrderedListData as OrderedListDataOriginal,
  BulletedListData as BulletedListDataOriginal,
  BlockquoteData as BlockquoteDataOriginal,
  CaptionData as CaptionDataOriginal,
  LayoutData as LayoutDataOriginal,
  ImageScalingScaling as ImageScalingScalingOriginal,
  ImageScalingScalingWithLiterals as ImageScalingScalingWithLiteralsOriginal,
  ImagePosition as ImagePositionOriginal,
  ImagePositionWithLiterals as ImagePositionWithLiteralsOriginal,
  Origin as OriginOriginal,
  OriginWithLiterals as OriginWithLiteralsOriginal,
  LayoutDataBackgroundType as LayoutDataBackgroundTypeOriginal,
  LayoutDataBackgroundTypeWithLiterals as LayoutDataBackgroundTypeWithLiteralsOriginal,
  BackdropType as BackdropTypeOriginal,
  BackdropTypeWithLiterals as BackdropTypeWithLiteralsOriginal,
  LayoutDataBackgroundImage as LayoutDataBackgroundImageOriginal,
  VerticalAlignmentAlignment as VerticalAlignmentAlignmentOriginal,
  VerticalAlignmentAlignmentWithLiterals as VerticalAlignmentAlignmentWithLiteralsOriginal,
  ResponsivenessBehaviour as ResponsivenessBehaviourOriginal,
  ResponsivenessBehaviourWithLiterals as ResponsivenessBehaviourWithLiteralsOriginal,
  DesignTarget as DesignTargetOriginal,
  DesignTargetWithLiterals as DesignTargetWithLiteralsOriginal,
  Banner as BannerOriginal,
  LayoutDataBackground as LayoutDataBackgroundOriginal,
  Backdrop as BackdropOriginal,
  LayoutCellData as LayoutCellDataOriginal,
  ShapeData as ShapeDataOriginal,
  ShapeDataStyles as ShapeDataStylesOriginal,
  CardData as CardDataOriginal,
  Scaling as ScalingOriginal,
  ScalingWithLiterals as ScalingWithLiteralsOriginal,
  ImagePositionPosition as ImagePositionPositionOriginal,
  ImagePositionPositionWithLiterals as ImagePositionPositionWithLiteralsOriginal,
  CardDataBackgroundType as CardDataBackgroundTypeOriginal,
  CardDataBackgroundTypeWithLiterals as CardDataBackgroundTypeWithLiteralsOriginal,
  CardDataBackground as CardDataBackgroundOriginal,
  BackgroundImage as BackgroundImageOriginal,
  TocData as TocDataOriginal,
  ListStyle as ListStyleOriginal,
  ListStyleWithLiterals as ListStyleWithLiteralsOriginal,
  Indentation as IndentationOriginal,
  IndentationWithLiterals as IndentationWithLiteralsOriginal,
  SmartBlockData as SmartBlockDataOriginal,
  SmartBlockDataType as SmartBlockDataTypeOriginal,
  SmartBlockDataTypeWithLiterals as SmartBlockDataTypeWithLiteralsOriginal,
  ColumnSize as ColumnSizeOriginal,
  ColumnSizeWithLiterals as ColumnSizeWithLiteralsOriginal,
  SmartBlockCellData as SmartBlockCellDataOriginal,
  Metadata as MetadataOriginal,
  DocumentStyle as DocumentStyleOriginal,
  TextNodeStyle as TextNodeStyleOriginal,
  BadgeList as BadgeListOriginal,
  Badge as BadgeOriginal,
  BadgeTypeType as BadgeTypeTypeOriginal,
  BadgeTypeTypeWithLiterals as BadgeTypeTypeWithLiteralsOriginal,
  EventStarted as EventStartedOriginal,
  EventEnded as EventEndedOriginal,
  EventReminder as EventReminderOriginal,
  EventPublished as EventPublishedOriginal,
  EventCloned as EventClonedOriginal,
  EventCanceled as EventCanceledOriginal,
  CreateEventRequest as CreateEventRequestOriginal,
  RequestedFields as RequestedFieldsOriginal,
  RequestedFieldsWithLiterals as RequestedFieldsWithLiteralsOriginal,
  CreateEventResponse as CreateEventResponseOriginal,
  CloneEventRequest as CloneEventRequestOriginal,
  CloneEventResponse as CloneEventResponseOriginal,
  CloneEventFromOtherSiteRequest as CloneEventFromOtherSiteRequestOriginal,
  CloneEventFromOtherSiteResponse as CloneEventFromOtherSiteResponseOriginal,
  UpdateEventRequest as UpdateEventRequestOriginal,
  UpdateEventResponse as UpdateEventResponseOriginal,
  PublishDraftEventRequest as PublishDraftEventRequestOriginal,
  PublishDraftEventResponse as PublishDraftEventResponseOriginal,
  CancelEventRequest as CancelEventRequestOriginal,
  CancelEventResponse as CancelEventResponseOriginal,
  BulkCancelEventsByFilterRequest as BulkCancelEventsByFilterRequestOriginal,
  CommonQueryV2 as CommonQueryV2Original,
  CommonQueryV2PagingMethodOneOf as CommonQueryV2PagingMethodOneOfOriginal,
  CommonSorting as CommonSortingOriginal,
  CommonSortOrder as CommonSortOrderOriginal,
  CommonSortOrderWithLiterals as CommonSortOrderWithLiteralsOriginal,
  CommonPaging as CommonPagingOriginal,
  BulkCancelEventsByFilterResponse as BulkCancelEventsByFilterResponseOriginal,
  DeleteEventRequest as DeleteEventRequestOriginal,
  DeleteEventResponse as DeleteEventResponseOriginal,
  BulkDeleteEventsByFilterRequest as BulkDeleteEventsByFilterRequestOriginal,
  BulkDeleteEventsByFilterResponse as BulkDeleteEventsByFilterResponseOriginal,
  QueryEventsRequest as QueryEventsRequestOriginal,
  QueryEventsResponse as QueryEventsResponseOriginal,
  CommonPagingMetadataV2 as CommonPagingMetadataV2Original,
  CommonCursors as CommonCursorsOriginal,
  ExportEventsRequest as ExportEventsRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  CursorPaging as CursorPagingOriginal,
  ExportEventsResponse as ExportEventsResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  CountEventsByStatusRequest as CountEventsByStatusRequestOriginal,
  CountEventsByStatusResponse as CountEventsByStatusResponseOriginal,
  FacetCounts as FacetCountsOriginal,
  ListUserEventsRequest as ListUserEventsRequestOriginal,
  UserFilter as UserFilterOriginal,
  Relation as RelationOriginal,
  RelationWithLiterals as RelationWithLiteralsOriginal,
  ListUserEventsResponse as ListUserEventsResponseOriginal,
  ListEventsByCategoryRequest as ListEventsByCategoryRequestOriginal,
  ListEventsByCategoryResponse as ListEventsByCategoryResponseOriginal,
  GetEventRequest as GetEventRequestOriginal,
  GetEventResponse as GetEventResponseOriginal,
  GetEventBySlugRequest as GetEventBySlugRequestOriginal,
  GetEventBySlugResponse as GetEventBySlugResponseOriginal,
  FindEventRequest as FindEventRequestOriginal,
  FindEventRequestFindByOneOf as FindEventRequestFindByOneOfOriginal,
  FindEventResponse as FindEventResponseOriginal,
  Empty as EmptyOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CreateEventApplicationErrors as CreateEventApplicationErrorsOriginal,
  CreateEventValidationErrors as CreateEventValidationErrorsOriginal,
  UpdateEventApplicationErrors as UpdateEventApplicationErrorsOriginal,
  UpdateEventValidationErrors as UpdateEventValidationErrorsOriginal,
  PublishDraftEventApplicationErrors as PublishDraftEventApplicationErrorsOriginal,
  CancelEventApplicationErrors as CancelEventApplicationErrorsOriginal,
  QueryEventsApplicationErrors as QueryEventsApplicationErrorsOriginal,
  CountEventsByStatusApplicationErrors as CountEventsByStatusApplicationErrorsOriginal,
} from './events-v3-event-wix-events-v-2.types.js';
